import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchFinancingStructure } from "../../api/controllers/financingStructuresController/financingStructuresController";
import { PeriodFeeRequestModel } from "../../api/models/PeriodFeeRequestModel";
import { calculatePeriodFee } from "../../api/controllers/calculationsController/calculationsController";

const abortControllers = new Map<string, AbortController>();

/**
 * Utility function to create or reuse an AbortController.
 * @param key Unique key for the request type.
 * @returns {AbortController} The AbortController instance for the request.
 */
export function getOrCreateAbortController(key: string): AbortController {
  // Abort the previous request if it exists
  if (abortControllers.has(key)) {
    abortControllers.get(key)?.abort();
  }

  // Create and store a new controller
  const newController = new AbortController();
  abortControllers.set(key, newController);
  return newController;
}

export const fetchFinancingStructureAsync = createAsyncThunk("calculator/fetchFinancingStructure", async () => {
  const abortController = getOrCreateAbortController("fetchFinancingStructure");
  return await fetchFinancingStructure(abortController);
});

export const fetchPeriodFeeAsync = createAsyncThunk("calculator/fetchPeriodFee", async (payload: { model: PeriodFeeRequestModel }) => {
  const abortController = getOrCreateAbortController("fetchPeriodFee");
  return await calculatePeriodFee(payload.model, abortController);
});
